// Imports => Constants
import { ENDPOINTS } from '@constants';

export class PurchasesAPI {
  constructor(Client, config) {
    this.Client = Client;
    this.config = config;
  }

  list = (params) => {
    return this.Client.get(ENDPOINTS.PURCHASES.LIST, { params }).then(
      (response) => response.data
    );
  };

  get_by_id = (uid, params) => {
    return this.Client.get(ENDPOINTS.PURCHASES.GET_BY_ID(uid), {
      params,
    }).then((response) => response.data.data);
  };
}

export default PurchasesAPI;
